import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { withBasePath } from '_config/basePath';
import { prepareAuthHeaders } from './auth';


interface ReferenceGroup {
    id: string;
    user_id: string;
    name: string;
}


export const myRefGroupsApi = createApi({
    reducerPath: 'myRefGroupsApi',
    baseQuery: fetchBaseQuery({
        baseUrl: withBasePath(''),
        prepareHeaders: prepareAuthHeaders,
        credentials: 'include',
    }),
    endpoints: (builder) => ({
        getMyRefGroups: builder.mutation<ReferenceGroup[], any>({
            query: (params = {}) => ({
                url: '/api/references/groups',
                method: 'GET',
                params
            }),
            transformResponse: (response: any) => {
                return response.references_groups;
            }
        }),
        createMyRefGroup: builder.mutation<any, any>({
            query: (body) => ({
                url: '/api/references/groups',
                method: 'PUT',
                body
            })
        }),
        updateMyRefGroup: builder.mutation<any, any>({
            query: (body) => ({
                url: '/api/references/groups',
                method: 'PATCH',
                body
            })
        }),
        deleteMyRefGroup: builder.mutation<any, any>({
            query: (body) => ({
                url: '/api/references/groups',
                method: 'DELETE',
                body
            })
        })

    })
});

export const { useGetMyRefGroupsMutation, useCreateMyRefGroupMutation, useDeleteMyRefGroupMutation, useUpdateMyRefGroupMutation } = myRefGroupsApi;


